<script setup lang="ts">
defineProps<{
  appName: string;
  iconSrc: string;
}>();
</script>

<template>
  <div class="fixed inset-0 z-[1900] grid place-items-center bg-[var(--pn-bg)] text-[var(--pn-text)]" data-pn-vue-loading aria-live="polite">
    <div class="flex flex-col items-center gap-3 text-sm text-[var(--pn-text-muted)]">
      <img :src="iconSrc" :alt="`${appName} loading`" class="pn-html-boot__icon rounded-2xl shadow-[0_12px_28px_rgb(15_23_42_/_14%)]" width="56" height="56" loading="eager" fetchpriority="high" decoding="sync" />
      <span class="inline-flex gap-1" aria-hidden="true"><i class="size-[.3125rem] rounded-full bg-current animate-[pn-boot-dot_1.2s_infinite_ease-in-out]" /><i class="size-[.3125rem] rounded-full bg-current animate-[pn-boot-dot_1.2s_.15s_infinite_ease-in-out]" /><i class="size-[.3125rem] rounded-full bg-current animate-[pn-boot-dot_1.2s_.3s_infinite_ease-in-out]" /></span>
    </div>
  </div>
</template>
